import type { Agencies } from "../components/QuoteCards/types";
export * from "./addresses";

export const ANNUAL = "annual";
export const YEARLY = "yearly";
export const MONTHLY = "monthly";

export const AIRBRAKE_PROJECT_ID: number = 90865;
export const AIRBRAKE_PROJECT_KEY = "8f2c6b9818d527c9e959af92547e1f03";

export const FOCUSABLE_ELEMENT_SELECTOR =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

// Answer keys
export const BUSINESS_CITY_KEY = "Business city";
export const US_STATE_ANSWER_KEY = "US state";

// Locale support
export const LOCALE_EN_GB = "en-GB";
export const LOCALE_EN_US = "en-US";
export const LOCALES = [LOCALE_EN_GB, LOCALE_EN_US] as const;
export const DEFAULT_LOCALE = LOCALE_EN_GB;

// Prepop
export const PREPOP_ENDPOINT_URL = "?step_action=prepopulate";

export type CreditRatingAgencyDescriptionsProps = {
  [key in Agencies]: {
    label: string;
    description: string;
  };
};

export const creditRatingAgencyDescriptions: CreditRatingAgencyDescriptionsProps =
  {
    ambest: {
      label: "A.M. Best",
      description:
        "The world’s largest credit rating agency specializing in the insurance industry. A.M. Best assesses the creditworthiness of and/or reports on insurance companies.",
    },
    demotech: {
      label: "Demotech Rating",
      description:
        "Demotech is a financial analysis firm specializing in evaluating the financial stability of regional and specialty insurers.",
    },
    // This is needed for the empty (UK) case
    "": {
      label: "",
      description: "",
    },
  };

export * from "./errors";
export * from "./experiments";
